<template>
  <div v-if="slides.length > 0" class="app-screens">
    <h2 class="app-screens__title">
      {{ appScreensTitle }}
    </h2>

    <Slider
      :slides="slides"
      :current-index="currentIndex"
      :video-fallback-text="videoFallbackText"
      :play-back-rate="playBackRate"
    />
  </div>
</template>

<script>
import Slider from './components/Slider'

export default {
  name: 'DotcomAppScreens',
  components: {
    Slider,
  },
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    currentActiveSlide: {
      type: String,
      default: '0',
    },
    appScreensTitle: {
      type: String,
      default: '',
    },
    videoFallbackText: {
      type: String,
      default: null,
    },
    playBackRate: {
      type: String,
      default: '4000',
    },
    slidesData: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    currentIndex: 0,
    slides: [],
  }),
  mounted() {
    try {
      this.slides = JSON.parse(this.slidesData)
    } catch (error) {
      console.error('Slides data parse error ', error)
    } finally {
      this.currentIndex = parseInt(this.currentActiveSlide)
    }
  },
}
</script>

<style lang="postcss">
.app-screens {
  --dotcom-app-screens-wrapper-width: 186px;
  --dotcom-app-screens-wrapper-height: 380px;
  --dotcom-app-screens-mask-width: 165px;
  --dotcom-app-screens-mask-height: 363px;
  --dotcom-app-screens-text-width: 200px;
  --dotcom-app-screens-transition-duration: 0.8s;
  --dotcom-app-screens-dot-dimensions: 16px;
  --dotcom-app-screens-text-max-height: none;

  &__title {
    font-weight: 700;
    font-size: 30px;
    margin-bottom: var(--spacing-8);
  }
}

@media (--sm) {
  .app-screens {
    --dotcom-app-screens-text-width: 300px;
    --dotcom-app-screens-text-max-height: 340px;
  }
}

@media (--md) {
  .app-screens {
    --dotcom-app-screens-wrapper-width: 325px;
    --dotcom-app-screens-wrapper-height: 627px;
    --dotcom-app-screens-mask-width: 290px;
    --dotcom-app-screens-mask-height: 605px;
    --dotcom-app-screens-text-max-height: 580px;
  }
}

@media (--lg) {
  .app-screens {
    --dotcom-app-screens-text-width: 400px;
  }
}
</style>
